import React from 'react';
import { defaultTheme } from './../../styles/theme/default';
import { IIcon } from './../../@types/icons';

export function Dislike ({ strokeColor, fillColor }: IIcon) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill={fillColor ? defaultTheme.colors[fillColor] || fillColor : 'none'}
      viewBox="0 0 16 16"
    >
      <path
        stroke={
          strokeColor
            ? defaultTheme.colors[strokeColor] || strokeColor
            : defaultTheme.colors.dimGray
        }
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4 9.5l3.025 5.156c.116.182.28.331.475.434.195.104.415.156.638.154.176.007.35-.021.515-.08.164-.06.314-.151.441-.267.127-.116.228-.255.298-.41.07-.153.107-.32.108-.487V9.5l4.682-.038c.192-.006.381-.05.554-.131.172-.08.325-.195.448-.336a1.245 1.245 0 00.3-1.026L14.54 1.63c-.04-.312-.199-.599-.446-.807A1.387 1.387 0 0013.2.5H4M1.023 9.5H4v-9H1.023a.481.481 0 00-.37.186.708.708 0 00-.153.448v7.732c0 .168.055.33.153.448a.481.481 0 00.37.186z"
      />
    </svg>
  );
}
